import { TriState } from "./Enums";

export class PaymentSearchParameters {
    pageNumber: number = 0;
    id: number = 0;
    supplierID: number = 0;
    typeID: number = 0;
    isDeleted: TriState = TriState.UseDefault;
}